import {Availability} from '../models/availability';
import {BehaviorSubject, Observable} from 'rxjs';
import {map} from 'rxjs/operators';

export class AvailabilitiesRepository {
    private subject: BehaviorSubject<{[employee_id: number]: {[date: string]: Availability}}>;

    constructor(seed: {[employee_id: number]: {[date: string]: Availability}}) {
        this.subject = new BehaviorSubject(seed);
    }

    public findByEmployeeId(employeeId: number): Observable<{[date: string]: Availability}> {
        return this.subject.pipe(map((availabilities) => availabilities[employeeId]));
    }

    public storeMany(updatedAvailabilities: {[employee_id: number]: {[date: string]: Availability}}) {
        const availabilities = this.subject.value;
        Object.keys(updatedAvailabilities).map((employeeId) => {
            const existing: {[date: string]: Availability} = availabilities[employeeId as any] || {};
            const updated: {[date: string]: Availability} = updatedAvailabilities[employeeId as any] || {};

            availabilities[employeeId as any] = {
                ...existing,
                ...updated,
            };
        });

        this.subject.next(availabilities);
    }

    public replace(availabilities: {[p: number]: {[p: string]: Availability}}) {
        this.subject.next(availabilities);
    }
}
